maskTelegramInput('[name="telegram"], [name="bp-telegram"], [name="fp-telegram"]')

function maskTelegramInput(inputSelector) {
    const telegramInputs = document.querySelectorAll(inputSelector);

    telegramInputs.forEach((telegramInput) => {
        telegramInput.addEventListener("focus", insertSymbolOnFocus);
        telegramInput.addEventListener("input", insertSymbolOnInput);
        telegramInput.addEventListener("blur", (e) => {
            const telegramInput = e.target;
            if (telegramInput.value === "@") {
                telegramInput.value = "";
            }
        });
    });

    function insertSymbolOnFocus(e) {
        const telegramInput = e.target;

        if (!telegramInput.value) {
            telegramInput.value = "@";
        } else if (!isValidInput(telegramInput.value)) {
            telegramInput.value = "@" + telegramInput.value;
        }
    }

    function insertSymbolOnInput(e) {
        const telegramInput = e.target;
        const extraSymbolIndex = telegramInput.value.indexOf("@", 1);

        if (!telegramInput.value) {
            telegramInput.value = "@";
        } else if (!isValidInput(telegramInput.value)) {
            telegramInput.value = "@" + telegramInput.value;
        }

        if (e.inputType === "insertFromPaste" && extraSymbolIndex) {
            telegramInput.value =
                telegramInput.value.slice(0, extraSymbolIndex) +
                telegramInput.value.slice(extraSymbolIndex + 1);
        }
    }

    function isValidInput(inputValue) {
        return inputValue.startsWith("@");
    }
}
